import React, { useState, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Typography from '@clasohlson/co-ui-components/Typography';
// import Grid from '@clasohlson/co-ui-components/Grid';
// import Column from '@clasohlson/co-ui-components/Column';
import Divider from '@clasohlson/co-ui-components/Divider';
import { LineItem } from '../orderModel';
import { OrderOverview } from '../components/order/OrderOverview';
import { ProductItem } from '../components/order/ProdcutItem';
import {
  useGlobalStateValue,
  ADD_OR_UPDATE_RETURN,
  REMOVE_RETURN,
  SET_ORDER,
  SET_RETURN_QUERY,
} from '../store/globalState';
import { Process } from '../components/order/Process';
import { IReturn } from '../models';
import { OrderHeader } from '../components/order/OrderHeader';
import { MobileBlock } from '../components/layout/MobileBlock';
import { BoxHeader } from '../components/layout/BoxHeader';
// import { CustomButton } from '../components/button/CustomButton';
import { getOrderByIdAndPostCode } from '../api';
import { useTranslation } from '../utils';
import { ButtonRow } from '../components/layout/ButtonRow';

const ProductList = styled.div`
  border: ${({ theme }) => `1px solid ${theme.colors.mediumGray}`};
  > div:last-of-type {
    border-bottom: 0;
  }
`;

const ProductsSelected = styled.span`
  font-weight: bold;
  font-size: 14px;
`;

const ProcessTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 3.19;
  text-align: center;
  @media screen and (max-width: 640px) {
    font-size: 14px;
    line-height: 1.29;
  }
`;

const useQuery = () => {
  const location = useLocation();
  return new URLSearchParams(location.search);
};

export const SelectProducts = () => {
  const {
    state: { currentOrder, returns },
    dispatch,
  } = useGlobalStateValue();
  // console.log(...returns);

  const [fetchingProduct, setFetchingProduct] = useState<boolean>(false);
  const [fetchError, setFetchError] = useState<boolean>(false);

  const query = useQuery();
  const history = useHistory();
  const { t } = useTranslation();
  const orderIdParam = query.get('order');
  const postCodeParam = query.get('postcode');

  useEffect(() => {
    const unlisten = history.listen(() => window.scrollTo(0, 0));
    return unlisten;
  });

  // console.log('orderId', orderIdParam, dateParam);

  const rowIsSelected = (rowNumber: number): boolean =>
    returns ? returns.some((r) => r.rowNumber === rowNumber) : false;

  const setInitQty = (qty: number) => (qty === 1 ? 1 : 0);

  const toggleArt = (prod: LineItem) => {
    if (rowIsSelected(prod.rowNumber)) {
      dispatch({ type: REMOVE_RETURN, payload: prod.rowNumber });
    } else {
      const ret: IReturn = { rowNumber: prod.rowNumber, qtyToReturn: setInitQty(prod.quantity) };
      dispatch({ type: ADD_OR_UPDATE_RETURN, payload: ret });
    }
  };

  const handleQtyChange = (prod: LineItem, num: number) => {
    const ret: IReturn = { rowNumber: prod.rowNumber, qtyToReturn: num };
    dispatch({ type: ADD_OR_UPDATE_RETURN, payload: ret });
  };

  const canGoNext = useMemo(() => {
    return returns.length !== 0 && !returns.some((pr) => pr.qtyToReturn === 0);
  }, [returns]);

  const allRowsAreValid = useMemo(() => {
    return !returns.some((pr) => pr.qtyToReturn === 0);
  }, [returns]);

  useEffect(() => {
    if (orderIdParam && postCodeParam) {
      setFetchingProduct(true);
      setFetchError(false);
      // console.log('Fetch product');
      dispatch({
        type: SET_RETURN_QUERY,
        payload: { orderNumber: orderIdParam, postCode: postCodeParam },
      });
      getOrderByIdAndPostCode(orderIdParam, postCodeParam)
        .then((order) => {
          // console.log('ORDER', order);
          dispatch({ type: SET_ORDER, payload: order });
          setFetchingProduct(false);
        })
        .catch((err) => {
          // console.error('ERROR', err);
          setFetchingProduct(false);
          setFetchError(true);
        });
    }
  }, [getOrderByIdAndPostCode, orderIdParam, postCodeParam]);

  if (fetchingProduct && !fetchError) {
    return <span>{t('fetchingOrderLabel')}</span>;
  }
  if (fetchError) {
    return <span>{t('orderError')}</span>;
  }
  return (
    <React.Fragment>
      <OrderHeader />
      {currentOrder && <OrderOverview order={currentOrder} />}
      <ProcessTitle>{t('stepOneTitle')}</ProcessTitle>
      <Process allDone={false} steps={3} activeStep={1} percentLine={returns.length > 0 ? 25 : 0} />
      <div>
        <BoxHeader>
          <MobileBlock hideForMobile>
            <Typography variant="h5" tag="span" color="#000">
              <strong>{t('productsInOrder')}</strong>
            </Typography>
          </MobileBlock>
          {/* <MobileBlock hideForMobile> */}
          <ProductsSelected>
            {returns.length} {t('productsSelected')}
          </ProductsSelected>
          {/* </MobileBlock> */}
        </BoxHeader>
        <ProductList>
          {currentOrder &&
            currentOrder.lineItems.map((prod: LineItem) => (
              <ProductItem
                key={prod.sku}
                disabled={prod.deliveredQuantity === 0}
                product={prod}
                selected={rowIsSelected(prod.rowNumber)}
                handleClick={toggleArt}
                handleQtyChange={handleQtyChange}
              />
            ))}
        </ProductList>
      </div>
      <Divider spacing="xsmall" color="#FFFFFF" />
      {!allRowsAreValid && (
        <>
          <Typography tag="span" variant="caption" color="#FF0000" align="center">
            {t('noReturnQtyMessage')}
          </Typography>
          <Divider spacing="xsmall" color="#FFFFFF" />
        </>
      )}
      <ButtonRow
        prevTitle={t('goBack')}
        nextTitle={t('continue')}
        prevAction={() => history.goBack()}
        nextAction={() => history.push('/return-details')}
        canGoNext={canGoNext}
        nextTestId="continueButton"
      />
    </React.Fragment>
  );
};
